import React, { useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Avatar, Typography } from "@material-ui/core";
import { useAuth } from "store/auth/selectors";
import { useDispatch } from "react-redux";
import { useConfig } from "store/settings/selectors";
import { subscribeToConfig } from "store/settings/actions";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "fit-content",
  },
  avatar: {
    width: 60,
    height: 60,
  },
  name: {
    marginTop: theme.spacing(1),
  },
}));

const Profile = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const auth = useAuth();

  const config = useConfig();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(subscribeToConfig());
  }, [dispatch]);

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src="/images/avatars/avatar_11.png"
        to="/account"
      />
      <Typography className={classes.name} variant="h4">
        Hello, {auth.user?.name ?? "User"}
      </Typography>
      <Typography variant="body2">{config?.name ?? "Business"}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string,
};

export default Profile;
